import { useState, useEffect } from 'react';
import { Grid, Skeleton } from '@mui/material'
import ScanButton from './scanButtonComponents/ScanButton';
import UploadButton from './scanButtonComponents/UploadButton';
import ExportButton from './scanButtonComponents/ExportButton';
import UploadAndExportButton from './scanButtonComponents/UploadAndExport';
import SlideButton from './scanButtonComponents/SlideButton';
import { useTranslation } from 'react-i18next';

export default function RemoteControlButtons(props: any) {
    const { machineScan, machineActive, disableScanButton, setDisableScanButton, cargoResponses, settings, settingsLoaded, showMachineSettings, machineCommand, setMachineCommand, scanButtonPressed, setScanButtonPressed } = props
    const { t } = useTranslation();
    const DEFAULT_SCAN_BUTTON_TEXT = t('control.inputs.buttons.scan');
    const [scanButtonText, setScanButtonText] = useState<string>("Scan");
    const [disableUploadExportButton, setDisableUploadExportButton] = useState<boolean>(true);
    const [disableUploadButton, setDisableUploadButton] = useState<boolean>(true);
    const [uploadButtonText, setUploadButtonText] = useState<string>("Upload");
    const [disableExportButton, setDisableExportButton] = useState<boolean>(true);
    const [scanAndUpload, setScanAndUpload] = useState<boolean>(false);
    const [uploadAndExport, setUploadAndExport] = useState<boolean>(false);

    useEffect(() => {
        if (settingsLoaded) {
            setScanAndUpload(settings.Scanner?.CombineRemoteUploadButtonEnabled?.value)
            setUploadAndExport(settings.Scanner?.CombineRemoteExportButtonEnabled?.value)
        }
    }, [settings, showMachineSettings, settingsLoaded])

    useEffect(() => {
        let ScanButtonText = DEFAULT_SCAN_BUTTON_TEXT;
        if (scanAndUpload === false && uploadAndExport === false) {
            if (settings.Scanner?.Upload?.value === "When saving") {
                if (settings.Scanner?.AutoExportEnabled.value === true) {
                    ScanButtonText = t('control.inputs.buttons.scanUploadExport') || ""
                } else {
                    ScanButtonText = t('control.inputs.buttons.scanUpload') || ""
                }
            } else {
                ScanButtonText = DEFAULT_SCAN_BUTTON_TEXT
            }
        }
        else if (scanAndUpload === true && uploadAndExport === true) {
            if (settings.Scanner?.Upload?.value === "When saving") {
                if (settings.Scanner?.AutoExportEnabled.value === true) {
                    ScanButtonText = t('control.inputs.buttons.scanUploadExport') || ""
                } else {
                    ScanButtonText = t('control.inputs.buttons.scanUpload') || ""
                }
            } else {
                ScanButtonText = t('control.inputs.buttons.scanUploadExport') || ""
            }
        } else if (scanAndUpload === true && uploadAndExport === false) {
            if (settings.Scanner?.Upload?.value === "When saving") {
                if (settings.Scanner?.AutoExportEnabled.value === true) {
                    ScanButtonText = t('control.inputs.buttons.scanUploadExport') || ""
                } else {
                    ScanButtonText = t('control.inputs.buttons.scanUpload') || ""
                }
            } else {
                ScanButtonText = t('control.inputs.buttons.scanUpload') || ""
            }
        }
        let interval: ReturnType<typeof setInterval> | null = null;
        
        if (settingsLoaded && scanButtonPressed) {
            let triggerDelay = settings.Scanner?.AutoBarcodeDelay?.value;
            if (triggerDelay && !isNaN(triggerDelay) && triggerDelay > 0) {
                let remainingTime = triggerDelay;
                setScanButtonText(t('control.inputs.buttons.scanningIn', { count: remainingTime }) || "Scanning In " + remainingTime + "s");
                interval = setInterval(() => {
                    remainingTime -= 1;
                    if (remainingTime > 0) {
                        setScanButtonText(t('control.inputs.buttons.scanningIn', { count: remainingTime }) || "Scanning In " + remainingTime + "s");
                    } else {
                        if (interval) {
                            clearInterval(interval);
                        }
                        setScanButtonPressed(false);
                        setScanButtonText(ScanButtonText);
                    }
                }, 1000);
            } else {
                setScanButtonText(ScanButtonText);
            }
        }
        
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [scanButtonPressed, settingsLoaded, setScanButtonPressed, settings.Scanner?.AutoBarcodeDelay?.value, scanAndUpload, uploadAndExport, t]);

    useEffect(() => {
        if (cargoResponses.length > 0) {
            setDisableUploadExportButton(false);
            setDisableUploadButton(false);
            if (!settings.Export.Url.value) {
                setDisableScanButton(true)
                setDisableExportButton(true);
                setDisableUploadExportButton(true);
            } else if (cargoResponses[0]['dimensionCode'] !== "0") {
                setDisableUploadExportButton(true);
                setDisableUploadButton(true);
            } else {
                setDisableScanButton(false);
                setDisableUploadExportButton(false);
                setDisableExportButton(false);
            }
        } else {
            setDisableUploadButton(true);
            setDisableUploadExportButton(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cargoResponses, showMachineSettings])

    useEffect(() => {
        if (cargoResponses.length > 0 && cargoResponses[0].uploaded === true) {
            setDisableUploadButton(true);
            setUploadButtonText("Uploaded") // The component will translate this
            if (settings.Export.Url.value) {
                setDisableExportButton(false);
            }
        } else {
            setUploadButtonText("Upload") // The component will translate this
            setDisableExportButton(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [machineScan])

    useEffect(() => {
        if (settingsLoaded) {
            if (scanAndUpload === false && uploadAndExport === false) {
                if (settings.Scanner?.Upload?.value === "When saving") {
                    if (settings.Scanner?.AutoExportEnabled.value === true) {
                        setScanButtonText(t('control.inputs.buttons.scanUploadExport') || "")
                    } else {
                        setScanButtonText(t('control.inputs.buttons.scanUpload') || "")
                    }
                } else {
                    setScanButtonText(DEFAULT_SCAN_BUTTON_TEXT)
                }
                setMachineCommand("dimension")
            }
            else if (scanAndUpload === false && uploadAndExport === true) {
                setScanButtonText(DEFAULT_SCAN_BUTTON_TEXT)
                setMachineCommand("dimension")
            }
            else if (scanAndUpload === true && uploadAndExport === true) {
                if (settings.Scanner?.Upload?.value === "When saving") {
                    if (settings.Scanner?.AutoExportEnabled.value === true) {
                        setScanButtonText(t('control.inputs.buttons.scanUploadExport') || "")
                    } else {
                        setScanButtonText(t('control.inputs.buttons.scanUpload') || "")
                    }
                } else {
                    setScanButtonText(t('control.inputs.buttons.scanUploadExport') || "")
                }
                setMachineCommand("dimensionUploadAndExport")
            }
            else if (scanAndUpload === true && uploadAndExport === false) {
                if (settings.Scanner?.Upload?.value === "When saving") {
                    if (settings.Scanner?.AutoExportEnabled.value === true) {
                        setScanButtonText(t('control.inputs.buttons.scanUploadExport') || "")
                    } else {
                        setScanButtonText(t('control.inputs.buttons.scanUpload') || "")
                    }
                } else {
                    setScanButtonText(t('control.inputs.buttons.scanUpload') || "")
                }
                setMachineCommand("dimensionAndUpload")
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scanAndUpload, uploadAndExport, setScanButtonText, settings, settingsLoaded, DEFAULT_SCAN_BUTTON_TEXT, showMachineSettings])

    let scanButtons;

    if (scanAndUpload === false && uploadAndExport === false) {
        scanButtons = <>
            {
                settingsLoaded && settings.Scanner?.Upload?.value === "When saving" ?
                    <>
                        <SlideButton machineScan={machineScan} scanButtonText={scanButtonText} machineCommand={machineCommand} machineActive={machineActive} disableScanButton={false} setScanButtonPressed={setScanButtonPressed}></SlideButton>
                        <ScanButton machineScan={machineScan} scanButtonText={scanButtonText} machineCommand={machineCommand} machineActive={machineActive} disableScanButton={false} setScanButtonPressed={setScanButtonPressed}></ScanButton>
                    </>
                    :
                    <>
                        <SlideButton machineScan={machineScan} scanButtonText={scanButtonText} machineCommand={machineCommand} machineActive={machineActive} disableScanButton={false} setScanButtonPressed={setScanButtonPressed}></SlideButton>
                        <ScanButton machineScan={machineScan} scanButtonText={scanButtonText} machineCommand={machineCommand} machineActive={machineActive} disableScanButton={false} setScanButtonPressed={setScanButtonPressed}></ScanButton>
                        <UploadButton machineScan={machineScan} machineActive={machineActive} disableUploadButton={disableUploadButton} uploadButtonText={uploadButtonText} settings={settings}></UploadButton>
                        <ExportButton machineScan={machineScan} machineActive={machineActive} disableExportButton={disableExportButton} settings={settings}></ExportButton>
                    </>
            }
        </>
    } else if (scanAndUpload === false && uploadAndExport === true) {
        scanButtons = <>
            <ScanButton machineScan={machineScan} scanButtonText={scanButtonText} machineCommand={machineCommand} machineActive={machineActive} disableScanButton={false} setScanButtonPressed={setScanButtonPressed}></ScanButton>
            <SlideButton machineScan={machineScan} scanButtonText={scanButtonText} machineCommand={machineCommand} machineActive={machineActive} disableScanButton={false} setScanButtonPressed={setScanButtonPressed}></SlideButton>
            <UploadAndExportButton machineScan={machineScan} machineActive={machineActive} disableUploadExportButton={disableUploadExportButton}></UploadAndExportButton>
        </>
    } else if (scanAndUpload === true && uploadAndExport === true) {
        scanButtons = <>
            <ScanButton machineScan={machineScan} scanButtonText={scanButtonText} machineCommand={machineCommand} machineActive={machineActive} disableScanButton={disableScanButton} setScanButtonPressed={setScanButtonPressed} scanAndUpload={scanAndUpload} uploadAndExport={uploadAndExport} settings={settings}  ></ScanButton>
            <SlideButton machineScan={machineScan} scanButtonText={scanButtonText} machineCommand={machineCommand} machineActive={machineActive} disableScanButton={disableScanButton} setScanButtonPressed={setScanButtonPressed}></SlideButton>
        </>
    } else if (scanAndUpload === true && uploadAndExport === false) {
        scanButtons = <>
            <ScanButton machineScan={machineScan} scanButtonText={scanButtonText} machineCommand={machineCommand} machineActive={machineActive} setScanButtonPressed={setScanButtonPressed}></ScanButton>
            <SlideButton machineScan={machineScan} scanButtonText={scanButtonText} machineCommand={machineCommand} machineActive={machineActive} setScanButtonPressed={setScanButtonPressed}></SlideButton>
            <ExportButton machineScan={machineScan} machineActive={machineActive} disableExportButton={disableExportButton}></ExportButton>
        </>
    } else {
        scanButtons = <>
            <Grid item>
                {t('control.inputs.buttons.unknownError')}
            </Grid>
        </>
    }

    if (!settingsLoaded) {
        return (
            <Grid item container
                direction="row"
                justifyContent="space-evenly"
                alignItems="center"
            >
                <Grid item xs={11}>
                    <Skeleton animation="wave" variant="rounded" width={"100%"} height={60} sx={{ bgcolor: '#EAEAF0', mt: 2 }} />
                </Grid>
            </Grid>
        )
    } else {
        return (
            <Grid item container
                direction="row"
                justifyContent="space-evenly"
                alignItems="center"
                md={12}>
                {scanButtons}
            </Grid>
        )
    }
}